module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/brands-desktop.2d52cbb2.png";